import { reactive } from "vue";
import { defineStore } from "pinia";
import { useLDFlag } from "launchdarkly-vue-client-sdk";

const useFeatureStore = defineStore("features", () => {
  const features = reactive({
    hasInternalToolsModule: useLDFlag("has-internal-tools-module"),
    hasNotifications: useLDFlag("notifications-module"),
    hasPlatformNotifications: useLDFlag("notifications"),
    hasPayerInvoiceSettings: useLDFlag("has-payer-invoice-settings"),
    hasThemeSwitcher: useLDFlag("has-theme-switcher", false),
    hasTermsAndConditions: useLDFlag("has-terms-and-conditions", false),
    hasNewDashboard: useLDFlag("dashboard-v3"),
    hasShipmentsDashboard: useLDFlag("shipments-v3"),
  });

  return {
    features,
  };
});

export default useFeatureStore;
